<template>
  <DropdownMenu v-model:open="isSettingsDropdownOpen">
    <DropdownMenuTrigger
      :class="
        cn(
          'text-accent-400 hover:bg-neutral-50/[0.12] py-2 px-3 inline-flex',
          isSettingsDropdownOpen && 'bg-neutral-50/[0.12]'
        )
      "
    >
      <ChevronsDown class="size-6" />
    </DropdownMenuTrigger>
    <DropdownMenuContent class="w-40 p-2">
      <Collaborators />
      <div>
        <Protect
          :permissions="[SYS_PERMISSIONS.SYS_PROJECTS_COMMENT]"
          :roles="['editor', 'viewer']"
        >
          <CommentsButton rounded @callback="onSelectItem" />
        </Protect>
        <Protect
          v-if="isLoggedIn || isPublicEnabled"
          :permissions="[SYS_PERMISSIONS.SYS_PROJECTS_READ]"
          :roles="['editor', 'viewer']"
          :skip-protect="isPublicEnabled"
        >
          <SearchButton rounded @callback="onSelectItem" />
        </Protect>
      </div>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { ChevronsDown } from 'lucide-vue-next';
import { cn } from '@ui/utils';
import { SYS_PERMISSIONS } from '@/constants.js';
import Protect from '@/hoc/Protect.vue';

import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from '@ui/components/dropdown-menu';
import Collaborators from './Collaborators.vue';
import CommentsButton from './CommentsButton.vue';
import SearchButton from './SearchButton.vue';

const store = useStore();

const isSettingsDropdownOpen = ref(false);
const isLoggedIn = computed(() => store.getters['user/account/getIsLoggedIn']);
const isPublicEnabled = computed(
  () => store.getters['project/getPublicLink'] !== null
);

const onSelectItem = () => {
  isSettingsDropdownOpen.value = false;
};
</script>
